import React from "react";
import FaqAccordion from "../faqAccordion/faqAccordion";

const Blog7 = ({ blog }) => {
  return (
    <div className="parent-container">
      <div className="main-container-blogpage" id="blog-content-container">
        <div className="category-tag">{blog.category}</div>
        <p className="headline-page">{blog.mainTitlePage}</p>
        <p className="date">{blog.publishDate}</p>
        <div className="image-container">
          <img className="img" src={blog.detailImage} alt={blog.imageAlt} />
        </div>

        <p className="paragraph-content">
          You remember the friend who still owes you ₹200.
          <br />
          But not the dozen ₹20 spent that quietly disappeared this week.
          <br />
          That’s not your fault.
          <br />
          Small spends are invisible – until they stack up and change your
          month.
        </p>

        <p className="sub-paragraph-heading">The Real Problem</p>

        <p className="paragraph-content">
          You’re not earning too little – your money just has no direction.
          <br />
          Without a map, every month feels the same: “kahan gaya paisa?”
          <br />
          That mental fog is what keeps most people stuck.
        </p>

        <p
          className="sub-paragraph-heading"
          style={{ color: "black", fontWeight: 500 }}
        >
          What You Actually Want
        </p>

        <p className="paragraph-content">
          Not a miracle. Not motivation.
          <br />
          Just clarity – one clean place to see where your money goes, what’s
          worth keeping, and what can be trimmed without guilt.
        </p>

        <p
          className="sub-paragraph-heading"
          style={{ color: "black", fontWeight: 500 }}
        >
          The Simple Fix
        </p>

        <ol style={{ listStyle: "none", paddingLeft: 0 }}>
          <li style={{ marginBottom: 10, color: "black" }}>
            1. Notice it. Track everything for 7 days – chai, snacks, recharge,
            all of it. You’ll be surprised.
          </li>
          <li style={{ marginBottom: 10, color: "black" }}>
            2. Automate a micro-save. Move ₹50/day (or whatever feels easy) into
            a separate pocket before you spend.
          </li>
          <li style={{ marginBottom: 10, color: "black" }}>
            3. Split smart. Keep one liquid pocket (for emergencies) and one
            growth pocket (micro SIP or digital gold).
          </li>
          <li style={{ marginBottom: 10, color: "black" }}>
            4. Stay consistent. Small daily actions compound quietly over time.
          </li>
        </ol>

        <p
          className="sub-paragraph-heading"
          style={{ color: "black", fontWeight: 500 }}
        >
          Where kPaisa Helps
        </p>

        <p className="paragraph-content">
          kPaisa gives you tools that make tracking effortless – spend
          analytics, micro-savings, gold SIPs, and digital gold starting from
          ₹1.
          <br />
          You see where your money moves, what habits are draining you, and how
          small daily actions quietly build stability.
          <br />
          No heavy financial talk – just clean, clear control.
        </p>

        <p
          className="sub-paragraph-heading"
          style={{ color: "black", fontWeight: 500 }}
        >
          Final Thought
        </p>

        <p className="paragraph-content">
          You don’t need to track forever. You just need to track long enough to
          see the pattern.
          <br />
          Because once you see it, you can’t unsee it – and that’s when
          everything changes.
          <br />
          <br />
          Most people never realize that expense tracking isn’t about numbers.
          It’s about awareness. And awareness is what quietly makes people
          unstoppable.
        </p>

        <div className="faq-heading-container">
          <p className="sub-paragraph-heading-faq">
            Frequently asked questions
          </p>
        </div>
        <FaqAccordion>
          <h4 className="faq-question">Isn’t tracking too much work?</h4>
          <p className="faq-answer">
            Not with automation. Once your app records and categorizes spends,
            you just review it weekly – 2 minutes, done.
          </p>
        </FaqAccordion>
        <FaqAccordion>
          <h4 className="faq-question">What if my income isn’t fixed?</h4>
          <p className="faq-answer">
            Use flexible micro-savings – skip one day, double the next. The
            point is awareness, not perfection.
          </p>
        </FaqAccordion>
        <FaqAccordion>
          <h4 className="faq-question">Does kPaisa charge for this?</h4>
          <p className="faq-answer">
            No hidden fees. kPaisa’s expense tools and micro-saving options are
            transparent and built for daily earners who want control, not
            complexity.
          </p>
        </FaqAccordion>
        <br></br>
        <br></br>
      </div>
    </div>
  );
};

export default Blog7;
